import React from 'react';
import { db } from '../utils/firebase';


const Cards = (props) => {


  
  const handleClick =(e,tipo)=>{

    console.log("tipo")
    console.log(tipo)
    db.collection("Estudiantes").add({
      email : props.varemail,
      tipo : tipo,
      fecha: Date()
    }).catch(alert);
  }
 

  return (
   
    <div class="container">
    <br></br><br></br><br></br>
      <div class="row ">
        
        <h5 class="rowcards">Descarga el aplicativo</h5>
        <br /><br />
        <div class="col-1"></div>
        <div class="col-sm-3">
          <div class="card aplicativo">
            <div class="card-body">
              <center>
                <h6 class="card-title">Windows</h6>
                <hr />
                <img src={require('../images/ventanas.png')} alt="..." class="img-thumbnail" />
                <p class="card-text">Disponible para Windows <br />7 - 8 - 10 -11</p>
                <button  class="btn btn-warning" onClick={event => handleClick(event, 'Windows')} ><a class="botondescargar" href="https://resourcesportal.blob.core.windows.net/aplicativos/UTPL_Evaluaciones_4.4.36.exe">Descargar</a></button>
                </center>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="card aplicativo">
            <div class="card-body">
              <center>
                <h6 class="card-title"> Android</h6>
                <hr />
                <img src={require('../images/androide.png')} alt="..." class="img-thumbnail" />
                <p class="card-text">Disponible para Android <br /> 5 - 6 - 7 - 8 - 9</p>
                <button  class="btn btn-warning" onClick={event => handleClick(event, 'Android')}><a class="botondescargar" href="https://resourcesportal.blob.core.windows.net/aplicativos/UTPL_Evaluaciones_4.4.26.apk">Descargar</a></button> </center>
            </div>
          </div>
        </div>
        <div class="col-sm-3">

          <div class="card aplicativo">
            <div class="card-body">
              <center>
                <h6 class="card-title">MAC</h6>
                <hr />

                <img src={require('../images/mac.png')} alt="..." class="img-thumbnail" />
                <p class="card-text">Para los estudiantes que poseen MAC, recomendamos seguir el tutorial </p>
                <button   class="btn btn-warning" onClick={event => handleClick(event, 'Mac')}><a class="botondescargar" target='_blank' href="https://support.apple.com/es-lamr/HT201468">Leer tutorial</a></button> </center>

            </div>

          </div>
        </div>
      </div>
      <br />
    </div>
  );
}


export default Cards;